import React from "react";

import keefleBOILED from '../images/emotes/keefleBOILED.png'
import keefleCUPID from '../images/emotes/keefleCUPID.png'
import keefleIDIOTGAMER from '../images/emotes/keefleIDIOTGAMER.png'
import keefleKEEF from '../images/emotes/keefleKEEF.png'
import keefleLINTLEDOG from '../images/emotes/keefleLINTLEDOG.png'
import keefleLUCI from '../images/emotes/keefleLUCI.png'
import keeflePINKMAN from '../images/emotes/keeflePINKMAN.png'
import keefleSIMP from '../images/emotes/keefleSIMP.png'
import keefleSLAY from '../images/emotes/keefleSLAY.png'
import griddyGoose from '../images/emotes/griddyGoose.gif'
import patrickCheer from '../images/emotes/patrickCheer.gif'

const emoteMap = {
  keefleBOILED: keefleBOILED,
  keefleCUPID: keefleCUPID,
  keefleIDIOTGAMER: keefleIDIOTGAMER,
  keefleKEEF: keefleKEEF,
  keefleLINTLEDOG: keefleLINTLEDOG,
  keefleLUCI: keefleLUCI,
  keeflePINKMAN: keeflePINKMAN,
  keefleSIMP: keefleSIMP,
  keefleSLAY: keefleSLAY,
  griddyGoose: griddyGoose,
  patrickCheer: patrickCheer
}

const processComment = (comment) => {
  const words = comment.split(" ");
  return words.map((word, idx) => {
    if (word in emoteMap) {
      if (word === "patrickCheer") {
        return <img key={idx} src={emoteMap[word]} alt={`keefler emote ${word}`} style={{ verticalAlign: "middle", margin: "5px" }} width={50} />
      } else {
        return <img key={idx} src={emoteMap[word]} alt={`keefler emote ${word}`} style={{ verticalAlign: "middle", margin: "5px" }} width={40} />
      }
    } else {
      return <span key={idx}>{word} </span>;
    }
  });
};

/** 0–1; native <video> defaults to 1 */
const WISH_VIDEO_VOLUME = 0.35;

const handwritingFonts = [
  { name: "Calligraffitti", size: 30 },
  { name: "Amatic SC", size: 40 },
  { name: "Nothing You Could Do", size: 30 },
  { name: "Nanum Pen Script", size: 40 },
];

/** wish.font: omit/null → cycle by page; string → family name; { name, size? } → explicit */
const getHandwritingStyle = (wish, currentPage) => {
  const fallback = handwritingFonts[currentPage % handwritingFonts.length];
  if (wish.font == null) {
    return { fontFamily: fallback.name, fontSize: fallback.size };
  }
  if (typeof wish.font === "string") {
    const match = handwritingFonts.find((f) => f.name === wish.font);
    return {
      fontFamily: wish.font,
      fontSize: match ? match.size : 35,
    };
  }
  const match = handwritingFonts.find((f) => f.name === wish.font.name);
  return {
    fontFamily: wish.font.name,
    fontSize: wish.font.size ?? match?.size ?? 35,
  };
};

const LeftAndRightPages = ({
  gif,
  wish,
  currentPage,
  onCardVideoPlaybackChange,
}) => {
  const handwritingStyle = getHandwritingStyle(wish, currentPage);

  const mediaSrc =
    wish.imageSrc || `https://media.giphy.com/media/${gif.id}/giphy.gif`;

  return (
    <div className="left-and-right-pages">
      <div className="left-page">
        {wish.videoSrc ? (
          <video
            src={wish.videoSrc}
            controls
            playsInline
            autoPlay
            width={700}
            className="GIFpic"
            onLoadedMetadata={(e) => {
              e.currentTarget.volume = WISH_VIDEO_VOLUME;
            }}
            onPlay={() => onCardVideoPlaybackChange?.(true)}
            onPause={() => onCardVideoPlaybackChange?.(false)}
            onEnded={() => onCardVideoPlaybackChange?.(false)}
          />
        ) : (
          <img
            src={mediaSrc}
            alt={gif.slug}
            width={700}
            className="GIFpic"
          />
        )}
      </div>
      <div className="right-page">
        <h1
          className="handwritten"
          style={{
            fontFamily: handwritingStyle.fontFamily,
            fontSize: handwritingStyle.fontSize,
          }}
        >
          {processComment(wish.comment)}
        </h1>
        <h2
          className="handwritten"
          style={{
            fontFamily: handwritingStyle.fontFamily,
            fontSize: handwritingStyle.fontSize,
          }}
        >
          - {wish.name}
        </h2>
      </div>
    </div>
  );
};

export default LeftAndRightPages;
